// Created on Sat Sep 14 22:00:53 2019

// @author: cyd

var colors = {
    "radar": {
        "r": [95, 0, 0, 0, 70, 195, 245, 244, 223, 190, 157, 117, 87, 87],
        "g": [89, 109, 109, 109, 205, 219, 203, 159, 102, 52, 16, 0, 0, 0],
        "b": [147, 154, 154, 154, 96, 38, 8, 33, 68, 94, 109, 107, 94, 94],
        "v": [1.9, 2, 6, 10, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
        "v": [1.9, 2, 6, 10, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
    },
    "dbz": {
        "r": [255, 95, 0, 0, 0, 70, 195, 245, 244, 223, 190, 157, 117, 87, 87],
        "g": [255, 89, 109, 109, 109, 205, 219, 203, 159, 102, 52, 16, 0, 0, 0],
        "b": [255, 147, 154, 154, 154, 96, 38, 8, 33, 68, 94, 109, 107, 94, 94],
        "v": [-0.1, 1.9, 2, 6, 10, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
    },
    "DBZSWC": {
        "r": [255, 95, 0, 0, 0, 70, 195, 245, 244, 223, 190, 157, 117, 87, 87],
        "g": [255, 89, 109, 109, 109, 205, 219, 203, 159, 102, 52, 16, 0, 0, 0],
        "b": [255, 147, 154, 154, 154, 96, 38, 8, 33, 68, 94, 109, 107, 94, 94],
        "v": [-0.1, 1.9, 2, 6, 10, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70],
    },
    // rgb(149, 137, 211), rgb(150, 209, 216), rgb(129, 204, 197), rgb(103, 180, 186), rgb(95, 143, 197),
    "temp": {
        "r": [21, 51, 82, 0, 0, 0, 149, 150, 129, 103, 95, 0, 0, 60, 125, 151, 132, 76, 3, 19, 138, 199, 236, 255, 255, 253, 255, 255, 255, 187, 115, 74],
        "g": [0, 4, 13, 13, 39, 69, 137, 209, 204, 180, 143, 109, 148, 186, 210, 232, 250, 250, 227, 199, 209, 254, 250, 240, 216, 169, 149, 110, 55, 0, 0, 0],
        "b": [37, 85, 136, 106, 148, 195, 211, 216, 197, 186, 197, 214, 244, 244, 244, 173, 152, 97, 30, 1, 1, 50, 8, 0, 0, 61, 0, 0, 0, 0, 9, 6],
        "v": [-90, -70, -50, -40, -35, -30, -25, -20, -15, -10, -5, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40],
    },

    "dew2": {
        "r": [21, 51, 82, 0, 0, 0, 149, 150, 129, 103, 95, 0, 0, 60, 125, 151, 132, 76, 3, 19, 138, 199, 236, 255, 255, 253, 255, 255, 255, 187, 115, 74],
        "g": [0, 4, 13, 13, 39, 69, 137, 209, 204, 180, 143, 109, 148, 186, 210, 232, 250, 250, 227, 199, 209, 254, 250, 240, 216, 169, 149, 110, 55, 0, 0, 0],
        "b": [37, 85, 136, 106, 148, 195, 211, 216, 197, 186, 197, 214, 244, 244, 244, 173, 152, 97, 30, 1, 1, 50, 8, 0, 0, 61, 0, 0, 0, 0, 9, 6],
        "v": [-90, -70, -50, -40, -35, -30, -25, -20, -15, -10, -5, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40],
    },
    "wind": {
        "r": [98, 97, 62, 74, 74, 77, 76, 109, 138, 161, 161, 141, 147, 111, 95, 91, 91],
        "g": [113, 113, 110, 147, 145, 142, 163, 160, 146, 135, 108, 65, 76, 92, 101, 136, 136],
        "b": [184, 183, 163, 169, 146, 121, 75, 55, 60, 63, 91, 92, 145, 155, 160, 161, 16],
        "v": [0.1, 0, 2.5, 5, 8, 10, 15, 20, 22, 25, 30, 35, 40, 45, 50, 60, 60.1]
    },
    "wind3": {
        "r": [235, 225, 215, 196, 146, 255, 255, 255, 255, 197, 182, 168, 153, 153, 95, 0],
        "g": [225, 210, 195, 165, 90, 255, 233, 216, 199, 237, 233, 228, 224, 224, 206, 0],
        "b": [241, 234, 227, 213, 178, 0, 0, 0, 0, 4, 4, 5, 6, 6, 10, 255],
        "v": [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
    },
    "wind6": {
        "r": [235, 225, 215, 196, 146, 255, 255, 255, 255, 197, 182, 168, 153, 153],
        "g": [225, 210, 195, 165, 90, 255, 233, 216, 199, 237, 233, 228, 224, 224],
        "b": [241, 234, 227, 213, 178, 0, 0, 0, 0, 4, 4, 5, 6, 6],
        "v": [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52],
    },

    //linear-gradient(to right, rgb(59, 124, 162),
    // rgb(59, 124, 162),
    // rgb(59, 124, 162),
    // rgb(59, 124, 162),
    // rgb(59, 126, 162),
    // rgb(59, 128, 162),
    // rgb(58, 133, 162),
    // rgb(58, 137, 162),
    // rgb(58, 153, 162),
    // rgb(50, 166, 111),
    // rgb(74, 164, 57),
    "vis": {
        "r": [164, 171, 162, 129, 74, 31, 65, 153],
        "g": [58, 54, 60, 162, 164, 164, 127, 153],
        "b": [154, 107, 59, 59, 57, 168, 197, 153],
        //"v": [24.1,15,10,6,3,1.2,0.8,0],
        "v": [0, 0.8, 1.2, 3, 6, 10, 15, 24.1]
    },
    // "ic":{
    // 	"r": [50,48,48,52,56,58,56,57,93,128,146,194,192,192],
    // 	"g": [156,125,99,101,103,81,75,60,54,48,54,76,118,162],
    // 	"b": [184,162,142,165,191,166,159,142,97,54,58,91,106,157],
    // 	"v": [10,20,30,40,50,63,72,75,80,82.5,85,90,95,100],
    // },
    "ic": {
        "r": [175, 175, 175, 175, 175, 0, 0, 0, 0, 132, 132, 132, 132, 132],
        "g": [238, 238, 238, 238, 238, 191, 191, 191, 191, 112, 112, 112, 112, 112],
        "b": [238, 238, 238, 238, 238, 255, 255, 255, 255, 255, 255, 255, 255, 255],
        "v": [10, 20, 30, 40, 50, 63, 72, 75, 80, 82.5, 85, 90, 95, 100],
    },
    "Ic": {
        "r": [89, 63, 180],
        "g": [161, 90, 82],
        "b": [186, 171, 92],
        "v": [1, 2, 3],
    },
    "Is": {
        "r": [174, 174, 171, 146, 103, 66, 54, 56, 56, 56, 56, 56],
        "g": [110, 136, 146, 157, 174, 174, 170, 158, 141, 132, 108, 71],
        "b": [56, 56, 56, 56, 58, 124, 154, 173, 174, 174, 163, 116],
        //"v": [0.02,0.035,0.04,0.045,0.050,0.060,0.070,0.080,0.085,0.090,0.095,0.1],
        //"v": [0.1,0.35,0.4,0.45,0.50,0.60,0.70,0.80,0.85,0.90,0.95,1],
        "v": [0.1, 0.15, 0.2, 0.3, 0.4, 0.6, 0.8, 1, 2, 3, 4, 5],
    },

    "dutton_array": [
        [80, 140, 62, 22],
        [121, 146, 28, 23],
        [171, 161, 14, 25],
        [174, 110, 56, 27],
        [174, 110, 56, 29],
        [174, 136, 56, 30],
        [174, 146, 56, 32],
        [223, 177, 6, 35],
        [243, 150, 6, 37],
        [224, 88, 37, 40],
        [232, 23, 42, 45]
    ],

    "dutton": {
        "r": [174, 174, 171, 146, 103, 66, 54, 56, 56, 56, 56, 56],
        "g": [110, 136, 146, 157, 174, 174, 170, 158, 141, 132, 108, 71],
        "b": [56, 56, 56, 56, 58, 124, 154, 173, 174, 174, 163, 116],
        "v": [22, 23, 25, 27, 29, 30, 32, 34, 35, 38, 40, 45],
    },

    "ws": {
        "r": [97, 73, 77, 98, 162, 150],
        "g": [113, 145, 142, 164, 113, 74],
        "b": [183, 169, 126, 58, 88, 141],
        "v": [0, 3, 5, 10, 15, 20],
    },
    "fs": {
        "r": [172, 135, 124, 111, 101],
        "g": [172, 119, 104, 87, 74],
        "b": [172, 84, 59, 26, 2],
        "v": [300, 690, 1390, 1600, 2000],
    },

    "cams": {
        "r": [172, 143, 135, 126, 124, 117, 110, 105, 100],
        "g": [172, 130, 119, 107, 104, 95, 86, 80, 73],
        "b": [172, 106, 85, 63, 58, 41, 25, 12, 0],
        "v": [0, 3, 10, 30, 60, 100, 300, 600, 800],
    },
    // "rain":{
    // 	"r": [95, 95, 95, 88, 54, 48, 44, 38, 30, 20, 14, 39, 81,166, 198, 245, 250, 250, 249],
    // 	"g": [88, 88, 95, 92, 115, 120, 122, 124, 129, 134, 141,144, 152, 156,157, 158, 159, 160, 162],
    // 	"b": [124, 124, 95, 139, 143, 142, 141, 134,137, 133,130, 119,101, 146,162, 188, 192, 192, 193],
    // 	"v": [1, 2, 5, 7.5, 10, 12.5, 15,17.5, 20, 25, 30, 35, 40, 50, 60, 70, 80, 90,1000]
    // },
    "rain": {
        "r": [59, 59, 59, 58, 58, 58, 58, 50, 74, 129, 162, 162, 171, 164],
        "g": [100, 120, 128, 133, 140, 147, 163, 166, 164, 162, 162, 60, 54, 58],
        "b": [162, 162, 162, 162, 162, 162, 162, 111, 57, 59, 59, 59, 107, 154],
        "v": [0.1, 0.3, 0.5, 1, 1.5, 2, 2.5, 3, 6, 10, 15, 25, 30, 35]
    },
    //background: linear-gradient(to right, rgb(174, 110, 56),
    // rgb(174, 110, 56),
    // rgb(174, 110, 56),
    // rgb(174, 110, 56),
    // rgb(174, 146, 56),
    // rgb(105, 174, 56),
    // rgb(54, 175, 148),
    // rgb(56, 158, 174),
    // rgb(56, 142, 174),
    // rgb(56, 133, 174),
    // rgb(56, 111, 166),
    // rgb(56, 71, 116),
    // rgb(56, 71, 116));
    "rh": {
        "r": [174, 174, 174, 174, 105, 54, 56, 56, 56, 56, 56, 56],
        "g": [110, 110, 110, 146, 174, 175, 158, 142, 133, 111, 71, 71],
        "b": [56, 56, 56, 56, 56, 148, 174, 174, 174, 166, 116, 116],
        "v": [0, 0.5, 0.8, 1, 5, 10, 30, 45, 60, 75, 90, 100]
    }
}
for (let key in colors) {

    if (colors[key]["v"]) {
        var v0 = colors[key]["v"][0];
        if (v0 != 0) {
            colors[key]["v"][0] = colors[key]["v"][0] - 0.01
        }
    }

}

colors["dbz"] = colors["radar"];
colors["mcappi"] = colors["radar"];
colors["t2"] = colors["t"];
colors["wind10"] = colors["wind"];
colors["gust"] = colors["wind"];
colors["yz"] = colors["qk"];
colors.dutton = { r: [], g: [], b: [], v: [] };
for (var k = 0; k < colors["dutton_array"].length; k++) {
    colors.dutton.r.push(colors["dutton_array"][k][0]);
    colors.dutton.g.push(colors["dutton_array"][k][1]);
    colors.dutton.b.push(colors["dutton_array"][k][2]);
    colors.dutton.v.push(colors["dutton_array"][k][3]);
}

export default colors